import { DocumentTextIcon } from "@heroicons/react/24/outline";
import { DropdownItem } from "../shared-components/DropdownCombo";
import { PersonFormState } from "../api/Reports";
import Button, {
  ButtonColorTypes,
  ButtonTypes,
} from "../shared-components/Button";
import LoadingSpinner from "../shared-components/LoadingSpinner";
import ErrorMessageContainer from "../shared-components/ErrorMessageContainer";

type Props = {
  blueprintItems: DropdownItem[];
  state: PersonFormState;
  behaviorKitItems: DropdownItem[];
  companyItems: DropdownItem[];
  isLoadingCreatePerson: boolean;
  close: () => void;
  handleSubmit: (event: any) => void;
  error: string | JSX.Element[];
};

export const PersonFormReview = ({
  blueprintItems,
  state,
  behaviorKitItems,
  companyItems,
  isLoadingCreatePerson,
  handleSubmit,
  close,
  error,
}: Props) => {
  return (
    <>
      <div className="flex items-center mb-5 gap-2">
        <DocumentTextIcon className="bg-green-50 text-green-700 rounded-full p-3 w-12"></DocumentTextIcon>
        <span className="font-semibold text-xl leading-7 text-gray-900">
          Summary
        </span>
      </div>
      <div className="border p-5 text-gray-90 rounded-lg">
        <div className="flex flex-col mb-4">
          <span className="text-gray-700">Screening Company:</span>
          <b className="font-semibold">
            {companyItems.find((item) => item.id === state.company_uuid)?.label}
          </b>
        </div>
        <div className="flex">
          <div className="flex flex-col gap-3  flex-1">
            <div className="flex flex-col">
              <span className="text-gray-700">Check Type:</span>
              <b className="font-semibold">
                {
                  blueprintItems.find(
                    (item) => item.id === state.blueprint_uuid
                  )?.label
                }
              </b>
            </div>
            <div className="flex flex-col ">
              <span className="text-gray-700">
                Name{state.names.length > 1 && "s"}:
              </span>
              {state.names.map((name) => (
                <b className="flex flex-col">
                  {name.first_name} {name.middle_name} {name.last_name}
                </b>
              ))}
            </div>
            <div className="flex flex-col ">
              <span className="text-gray-700">
                Phone{state.phones.length > 1 && "s"}:
              </span>
              {state.phones.map((phone) => (
                <span className="flex font-semibold flex-col">
                  {phone.raw_number}
                </span>
              ))}
            </div>
            <div className="flex flex-col ">
              <span className="text-gray-700">
                Address{state.addresses.length > 1 && "s"}:
              </span>
              {state.addresses.map((addresses) => (
                <span className="flex font-semibold flex-col">
                  {addresses.line1}
                </span>
              ))}
            </div>
            <div className="flex flex-col ">
              <span className="text-gray-700">Employment:</span>
              {state.jobs.map((job) => (
                <span className="flex font-semibold flex-col">{job.title}</span>
              ))}
            </div>
            <div className="flex flex-col ">
              <span className="text-gray-700">Client Reference:</span>
              <b className="flex flex-col">{state.custom_id}</b>
            </div>
          </div>
          <div className="flex flex-col gap-3 flex-1">
            <div className="flex flex-col ">
              <span className="text-gray-700">Behavior Kit:</span>
              <span className="flex font-semibold flex-col">
                {
                  behaviorKitItems.find(
                    (kit) => kit.id === state.behavior_kit_uuid
                  )?.label
                }
              </span>
            </div>
            <div className="flex flex-col ">
              <span className="text-gray-700">
                Email{state.names.length > 1 && "s"}:
              </span>
              {state.emails.map((email) => (
                <span className="flex font-semibold flex-col">
                  {email.address}
                </span>
              ))}
            </div>
            <div className="flex flex-col ">
              <span className="text-gray-700">Birthday:</span>
              <span className="flex font-semibold flex-col">
                {state.birth_date}
              </span>
            </div>
            <div className="flex flex-col ">
              <span className="text-gray-700">Education:</span>
              {state.degrees.map((school) => (
                <span className="flex font-semibold flex-col">
                  {school.educator}
                </span>
              ))}
            </div>
            <div className="flex flex-col ">
              <span className="text-gray-700">Social Media:</span>
              {state.profiles.map((profile) => (
                <span className="flex  font-semibold flex-col">{profile}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="flex mt-5 text-gray-700 text-sm flex-col gap-5">
        <p>
          By clicking the "Submit" button below, you confirm that the provided
          information is accurate and complete.
        </p>

        {error && (
          <ErrorMessageContainer>
            <>{error}</>
          </ErrorMessageContainer>
        )}
        <div className="flex gap-1 justify-end">
          <Button
            type={ButtonTypes.default}
            text="Cancel"
            colorType={ButtonColorTypes.cancel}
            onClick={close}
          />
          <Button
            type={ButtonTypes.default}
            disabled={isLoadingCreatePerson}
            text={isLoadingCreatePerson ? <LoadingSpinner /> : "Submit"}
            colorType={ButtonColorTypes.success}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </>
  );
};
